import { v4 as uuidv4 } from "uuid";

export default {
    methods: {
        /**
         * The function `getAlbumByTag` is used to get the albums by tag
         * @param room - Room number
         * @param arrivalDate - The date the guest arrived at the hotel.
         * @param departureDate - The date the guest is leaving the hotel.
         * @param [guestName] - The name of the guest.
         * @returns The response from the API.
         */
        async getAlbumByRoom(room, arrivalDate, departureDate, guestName = "") {
            try {
                this.$store.dispatch("setLoading", true);
                /* Creating an object with the parameters to send to the API. */
                const parameters = {
                    type: 2,
                    params: { Room: room, ArrivalDate: arrivalDate, DepartureDate: departureDate, GuestName: "" }
                };
                /* Calling the API to get the albums by email. */
                const response = await this.$store.dispatch('getAlbums', parameters);
                // Validamos si hay algun error
                if (!response[0].PhotoExperiences.length) {
                    this.$store.dispatch("setLoading", false);
                    Vue.$toast.open({
                        message: this.$t(
                            "Validations.tag_dont_have_multimedios"
                        ),
                        type: "error",
                    });
                    this.$store.dispatch("setLoading", false);

                    return;
                }

                /* Calling the function `formatAlbumsByEmail` and passing in the response from the API. */
                this.formatAlbumsByRoom(response);

                // We activate the tab to show the codes
                this.$store.dispatch("setReservationsTab", true);
                this.$store.dispatch("setTypeCodeTab", 2);

                /* A method that is used to show a loading icon on the screen. */
                this.$store.dispatch("setLoading", false);

                Vue.$toast.open({
                    message: this.$t("messages.album_add_successfully"),
                    type: "success",
                });

                /* Checking if the response from the API has data. If it does, it will redirect the
                user to the `albumes` route. */
                if (response.length && this.$route.name !== 'albumes') {
                    this.$router.push({ name: 'albumes' })
                }
            } catch (error) {
                this.$store.dispatch("setLoading", false);
                
            }
        },
        formatAlbumsByRoom(data) {
            data.forEach((item) => {
                let album = {};
                const photoDetails = item.PhotoDetails;

                album.uuid = uuidv4();
                album.code = photoDetails.Room;
                album.ArrivalDate = photoDetails.ArrivalDate;
                album.DepartureDate = photoDetails.DepartureDate;
                album.GuestName = photoDetails.GuestName;
                album.getCode = [];
                album.park = item.PhotoExperiences;
                album.Type = photoDetails.Type;

                // We store the album
                this.$store.dispatch("setAlbum", [album]);

            });
        }
    }
};